import { Modal } from "antd"
import { Route } from "../routingApi"
import { useDeleteRouteMutation } from "../routingQueries"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleX } from "@fortawesome/pro-solid-svg-icons"
import { red } from '@ant-design/colors'

export type Props = {
  route: Route | null
  isOpen: boolean
  onClose: () => void
}

const DeleteRouteModal = ({ route, isOpen, onClose }: Props) => {

  const deleteRouteMutation = useDeleteRouteMutation()

  const handleDelete = () => {
    if (route) {
      deleteRouteMutation.mutate({ routeId: route.id })
    }
    onClose()
  }

  if (!route) {
    return null
  }

  return <Modal 
      open={isOpen} 
      onCancel={onClose} 
      onOk={handleDelete}
      title=<span>
        <FontAwesomeIcon style={{ marginRight: '10px' }} color={red.primary} icon={faCircleX} />
        <span>Delete Route</span>
      </span>
      >
    <p>Are you sure you want to delete <strong>{route.name}</strong>? This action <strong>will remove all scheduled events</strong> and cannot be undone.</p>
  </Modal>
}

export default DeleteRouteModal